// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,json_types=true"
// @generated from file links/v1/links.proto (package links.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Identity, IdentityJson } from "../../codes/v3/codes_pb";
import { file_codes_v3_codes } from "../../codes/v3/codes_pb";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import type { PaginationArguments, PaginationArgumentsJson, PaginationPageInfo, PaginationPageInfoJson } from "../../common/v1/pagination_pb";
import { file_common_v1_pagination } from "../../common/v1/pagination_pb";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import type { FieldMask, FieldMaskJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file links/v1/links.proto.
 */
export const file_links_v1_links: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_codes_v3_codes, file_common_v1_annotations, file_common_v1_pagination, file_google_api_annotations, file_google_protobuf_field_mask, file_google_protobuf_timestamp],
	);

/**
 * @generated from message links.v1.Link
 */
export type Link = Message<"links.v1.Link"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string domain_id = 2;
	 */
	domainId: string;

	/**
	 * @generated from field: string url = 3;
	 */
	url: string;

	/**
	 * @generated from field: string hash = 4;
	 */
	hash: string;

	/**
	 * @generated from field: string org_id = 5;
	 */
	orgId: string;

	/**
	 * @generated from field: map<string, string> metadata = 6;
	 */
	metadata: { [key: string]: string };

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 7;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 8;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 9;
	 */
	deletedAt?: Timestamp | undefined;

	/**
	 * @generated from field: string short_url = 10;
	 */
	shortUrl: string;

	/**
	 * @generated from field: string path_suffix = 11;
	 */
	pathSuffix: string;

	/**
	 * @generated from field: codes.v3.Identity identity = 12;
	 */
	identity?: Identity | undefined;
};

/**
 * @generated from message links.v1.Link
 */
export type LinkJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string domain_id = 2;
	 */
	domainId?: string;

	/**
	 * @generated from field: string url = 3;
	 */
	url?: string;

	/**
	 * @generated from field: string hash = 4;
	 */
	hash?: string;

	/**
	 * @generated from field: string org_id = 5;
	 */
	orgId?: string;

	/**
	 * @generated from field: map<string, string> metadata = 6;
	 */
	metadata?: { [key: string]: string };

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 7;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 8;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 9;
	 */
	deletedAt?: TimestampJson;

	/**
	 * @generated from field: string short_url = 10;
	 */
	shortUrl?: string;

	/**
	 * @generated from field: string path_suffix = 11;
	 */
	pathSuffix?: string;

	/**
	 * @generated from field: codes.v3.Identity identity = 12;
	 */
	identity?: IdentityJson;
};

/**
 * Describes the message links.v1.Link.
 * Use `create(LinkSchema)` to create a new message.
 */
export const LinkSchema: GenMessage<Link, { jsonType: LinkJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 0);

/**
 * A customer-defined consent/policy footer link beyond the predefined set
 * (e.g. "Terms of Use", "Children's Online Privacy Policy"). The id is a
 * client-generated stable identifier, opaque to this service.
 *
 * @generated from message links.v1.CustomPolicyLink
 */
export type CustomPolicyLink = Message<"links.v1.CustomPolicyLink"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string label = 2;
	 */
	label: string;

	/**
	 * @generated from field: string url = 3;
	 */
	url: string;
};

/**
 * A customer-defined consent/policy footer link beyond the predefined set
 * (e.g. "Terms of Use", "Children's Online Privacy Policy"). The id is a
 * client-generated stable identifier, opaque to this service.
 *
 * @generated from message links.v1.CustomPolicyLink
 */
export type CustomPolicyLinkJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string label = 2;
	 */
	label?: string;

	/**
	 * @generated from field: string url = 3;
	 */
	url?: string;
};

/**
 * Describes the message links.v1.CustomPolicyLink.
 * Use `create(CustomPolicyLinkSchema)` to create a new message.
 */
export const CustomPolicyLinkSchema: GenMessage<CustomPolicyLink, { jsonType: CustomPolicyLinkJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 1);

/**
 * A single entry in a domain's ordered footer privacy-links list. Order is
 * implied by array position, and predefined and custom links interleave freely.
 * A predefined entry is a reference (by key) to data stored in the scalar Domain
 * fields; a custom entry carries its own label/url.
 *
 * @generated from message links.v1.PrivacyLink
 */
export type PrivacyLink = Message<"links.v1.PrivacyLink"> & {
	/**
	 * @generated from oneof links.v1.PrivacyLink.link
	 */
	link:
		| {
				/**
				 * One of privacy_policy, cookie_preferences, do_not_sell, or privacy_choices.
				 *
				 * @generated from field: string predefined_key = 1;
				 */
				value: string;
				case: "predefinedKey";
		  }
		| {
				/**
				 * @generated from field: links.v1.CustomPolicyLink custom = 2;
				 */
				value: CustomPolicyLink;
				case: "custom";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * A single entry in a domain's ordered footer privacy-links list. Order is
 * implied by array position, and predefined and custom links interleave freely.
 * A predefined entry is a reference (by key) to data stored in the scalar Domain
 * fields; a custom entry carries its own label/url.
 *
 * @generated from message links.v1.PrivacyLink
 */
export type PrivacyLinkJson = {
	/**
	 * One of privacy_policy, cookie_preferences, do_not_sell, or privacy_choices.
	 *
	 * @generated from field: string predefined_key = 1;
	 */
	predefinedKey?: string;

	/**
	 * @generated from field: links.v1.CustomPolicyLink custom = 2;
	 */
	custom?: CustomPolicyLinkJson;
};

/**
 * Describes the message links.v1.PrivacyLink.
 * Use `create(PrivacyLinkSchema)` to create a new message.
 */
export const PrivacyLinkSchema: GenMessage<PrivacyLink, { jsonType: PrivacyLinkJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 2);

/**
 * @generated from message links.v1.Domain
 */
export type Domain = Message<"links.v1.Domain"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string domain = 2;
	 */
	domain: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description: string;

	/**
	 * @generated from field: links.v1.DomainStatus status = 5;
	 */
	status: DomainStatus;

	/**
	 * @generated from field: string workspace_id = 6;
	 */
	workspaceId: string;

	/**
	 * @generated from field: bool workspace_default = 7;
	 */
	workspaceDefault: boolean;

	/**
	 * @generated from field: bool active = 8;
	 */
	active: boolean;

	/**
	 * @generated from field: string external_id = 9;
	 */
	externalId: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 10;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 11;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 12;
	 */
	deletedAt?: Timestamp | undefined;

	/**
	 * @generated from field: repeated links.v1.WorkspaceDefault workspaces = 13;
	 */
	workspaces: WorkspaceDefault[];

	/**
	 * @generated from field: bool global_default = 14;
	 */
	globalDefault: boolean;

	/**
	 * @generated from field: string one_trust_id = 15;
	 */
	oneTrustId: string;

	/**
	 * @generated from field: string privacy_policy_link_hash = 16;
	 */
	privacyPolicyLinkHash: string;

	/**
	 * @generated from field: string cookie_preferences_link_label = 17;
	 */
	cookiePreferencesLinkLabel: string;

	/**
	 * @generated from field: string do_not_sell_policy_link_url = 18;
	 */
	doNotSellPolicyLinkUrl: string;

	/**
	 * @generated from field: string do_not_sell_policy_link_label = 19;
	 */
	doNotSellPolicyLinkLabel: string;

	/**
	 * @generated from field: string privacy_preferences_url = 20;
	 */
	privacyPreferencesUrl: string;

	/**
	 * @generated from field: string privacy_preferences_label = 21;
	 */
	privacyPreferencesLabel: string;

	/**
	 * @generated from field: string fallback_redirect_url = 22;
	 */
	fallbackRedirectUrl: string;

	/**
	 * Protocol-stripped URL shown as the privacy smile when a domain uses its own
	 * privacy policy URL directly (no shortlink redirect). Empty = default {domain}/{hash}.
	 *
	 * @generated from field: string privacy_smile_url = 23;
	 */
	privacySmileUrl: string;

	/**
	 * Ordered footer privacy links, both predefined references and custom, with order
	 * implied by position. An empty list means the renderer falls back to its legacy
	 * order. This service stores the ordering but never acts on it, since that's a UI concern.
	 *
	 * @generated from field: repeated links.v1.PrivacyLink privacy_links = 24;
	 */
	privacyLinks: PrivacyLink[];

	/**
	 * @generated from field: string privacy_policy_link_label = 25;
	 */
	privacyPolicyLinkLabel: string;
};

/**
 * @generated from message links.v1.Domain
 */
export type DomainJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string domain = 2;
	 */
	domain?: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId?: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description?: string;

	/**
	 * @generated from field: links.v1.DomainStatus status = 5;
	 */
	status?: DomainStatusJson;

	/**
	 * @generated from field: string workspace_id = 6;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: bool workspace_default = 7;
	 */
	workspaceDefault?: boolean;

	/**
	 * @generated from field: bool active = 8;
	 */
	active?: boolean;

	/**
	 * @generated from field: string external_id = 9;
	 */
	externalId?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 10;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 11;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 12;
	 */
	deletedAt?: TimestampJson;

	/**
	 * @generated from field: repeated links.v1.WorkspaceDefault workspaces = 13;
	 */
	workspaces?: WorkspaceDefaultJson[];

	/**
	 * @generated from field: bool global_default = 14;
	 */
	globalDefault?: boolean;

	/**
	 * @generated from field: string one_trust_id = 15;
	 */
	oneTrustId?: string;

	/**
	 * @generated from field: string privacy_policy_link_hash = 16;
	 */
	privacyPolicyLinkHash?: string;

	/**
	 * @generated from field: string cookie_preferences_link_label = 17;
	 */
	cookiePreferencesLinkLabel?: string;

	/**
	 * @generated from field: string do_not_sell_policy_link_url = 18;
	 */
	doNotSellPolicyLinkUrl?: string;

	/**
	 * @generated from field: string do_not_sell_policy_link_label = 19;
	 */
	doNotSellPolicyLinkLabel?: string;

	/**
	 * @generated from field: string privacy_preferences_url = 20;
	 */
	privacyPreferencesUrl?: string;

	/**
	 * @generated from field: string privacy_preferences_label = 21;
	 */
	privacyPreferencesLabel?: string;

	/**
	 * @generated from field: string fallback_redirect_url = 22;
	 */
	fallbackRedirectUrl?: string;

	/**
	 * Protocol-stripped URL shown as the privacy smile when a domain uses its own
	 * privacy policy URL directly (no shortlink redirect). Empty = default {domain}/{hash}.
	 *
	 * @generated from field: string privacy_smile_url = 23;
	 */
	privacySmileUrl?: string;

	/**
	 * Ordered footer privacy links, both predefined references and custom, with order
	 * implied by position. An empty list means the renderer falls back to its legacy
	 * order. This service stores the ordering but never acts on it, since that's a UI concern.
	 *
	 * @generated from field: repeated links.v1.PrivacyLink privacy_links = 24;
	 */
	privacyLinks?: PrivacyLinkJson[];

	/**
	 * @generated from field: string privacy_policy_link_label = 25;
	 */
	privacyPolicyLinkLabel?: string;
};

/**
 * Describes the message links.v1.Domain.
 * Use `create(DomainSchema)` to create a new message.
 */
export const DomainSchema: GenMessage<Domain, { jsonType: DomainJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 3);

/**
 * @generated from message links.v1.WorkspaceDefault
 */
export type WorkspaceDefault = Message<"links.v1.WorkspaceDefault"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string domain_id = 2;
	 */
	domainId: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string org_id = 4;
	 */
	orgId: string;

	/**
	 * @generated from field: bool workspace_default = 5;
	 */
	workspaceDefault: boolean;

	/**
	 * @generated from field: bool org_default = 6;
	 */
	orgDefault: boolean;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 7;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 8;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 9;
	 */
	deletedAt?: Timestamp | undefined;
};

/**
 * @generated from message links.v1.WorkspaceDefault
 */
export type WorkspaceDefaultJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string domain_id = 2;
	 */
	domainId?: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string org_id = 4;
	 */
	orgId?: string;

	/**
	 * @generated from field: bool workspace_default = 5;
	 */
	workspaceDefault?: boolean;

	/**
	 * @generated from field: bool org_default = 6;
	 */
	orgDefault?: boolean;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 7;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 8;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 9;
	 */
	deletedAt?: TimestampJson;
};

/**
 * Describes the message links.v1.WorkspaceDefault.
 * Use `create(WorkspaceDefaultSchema)` to create a new message.
 */
export const WorkspaceDefaultSchema: GenMessage<WorkspaceDefault, { jsonType: WorkspaceDefaultJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 4);

/**
 * @generated from message links.v1.CreateLinkRequest
 */
export type CreateLinkRequest = Message<"links.v1.CreateLinkRequest"> & {
	/**
	 * @generated from field: string url = 1;
	 */
	url: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: optional string domain_id = 3;
	 */
	domainId?: string | undefined;

	/**
	 * @generated from field: string workspace_id = 4 [deprecated = true];
	 * @deprecated
	 */
	workspaceId: string;

	/**
	 * @generated from field: string batch_id = 5;
	 */
	batchId: string;

	/**
	 * @generated from field: string path_suffix = 6;
	 */
	pathSuffix: string;

	/**
	 * @generated from field: string hash = 7;
	 */
	hash: string;

	/**
	 * @generated from field: codes.v3.Identity identity = 8;
	 */
	identity?: Identity | undefined;
};

/**
 * @generated from message links.v1.CreateLinkRequest
 */
export type CreateLinkRequestJson = {
	/**
	 * @generated from field: string url = 1;
	 */
	url?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: optional string domain_id = 3;
	 */
	domainId?: string;

	/**
	 * @generated from field: string workspace_id = 4 [deprecated = true];
	 * @deprecated
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string batch_id = 5;
	 */
	batchId?: string;

	/**
	 * @generated from field: string path_suffix = 6;
	 */
	pathSuffix?: string;

	/**
	 * @generated from field: string hash = 7;
	 */
	hash?: string;

	/**
	 * @generated from field: codes.v3.Identity identity = 8;
	 */
	identity?: IdentityJson;
};

/**
 * Describes the message links.v1.CreateLinkRequest.
 * Use `create(CreateLinkRequestSchema)` to create a new message.
 */
export const CreateLinkRequestSchema: GenMessage<CreateLinkRequest, { jsonType: CreateLinkRequestJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 5);

/**
 * @generated from message links.v1.CreateLinkResponse
 */
export type CreateLinkResponse = Message<"links.v1.CreateLinkResponse"> & {
	/**
	 * @generated from field: string link = 1;
	 */
	link: string;

	/**
	 * @generated from field: string hash = 2;
	 */
	hash: string;

	/**
	 * @generated from field: string url = 3;
	 */
	url: string;

	/**
	 * @generated from field: string domain_id = 4;
	 */
	domainId: string;

	/**
	 * @generated from field: string batch_id = 5;
	 */
	batchId: string;

	/**
	 * @generated from field: string path_suffix = 6;
	 */
	pathSuffix: string;

	/**
	 * @generated from field: codes.v3.Identity identity = 7;
	 */
	identity?: Identity | undefined;
};

/**
 * @generated from message links.v1.CreateLinkResponse
 */
export type CreateLinkResponseJson = {
	/**
	 * @generated from field: string link = 1;
	 */
	link?: string;

	/**
	 * @generated from field: string hash = 2;
	 */
	hash?: string;

	/**
	 * @generated from field: string url = 3;
	 */
	url?: string;

	/**
	 * @generated from field: string domain_id = 4;
	 */
	domainId?: string;

	/**
	 * @generated from field: string batch_id = 5;
	 */
	batchId?: string;

	/**
	 * @generated from field: string path_suffix = 6;
	 */
	pathSuffix?: string;

	/**
	 * @generated from field: codes.v3.Identity identity = 7;
	 */
	identity?: IdentityJson;
};

/**
 * Describes the message links.v1.CreateLinkResponse.
 * Use `create(CreateLinkResponseSchema)` to create a new message.
 */
export const CreateLinkResponseSchema: GenMessage<CreateLinkResponse, { jsonType: CreateLinkResponseJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 6);

/**
 * @generated from message links.v1.BatchCreateLinksRequest
 */
export type BatchCreateLinksRequest = Message<"links.v1.BatchCreateLinksRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: optional string domain_id = 2;
	 */
	domainId?: string | undefined;

	/**
	 * @generated from field: repeated string urls = 3;
	 */
	urls: string[];

	/**
	 * @generated from field: repeated string hashes = 7;
	 */
	hashes: string[];

	/**
	 * @generated from field: string workspace_id = 4 [deprecated = true];
	 * @deprecated
	 */
	workspaceId: string;

	/**
	 * @generated from field: string batch_id = 5;
	 */
	batchId: string;

	/**
	 * @generated from field: string path_suffix = 6;
	 */
	pathSuffix: string;

	/**
	 * @generated from field: bool use_perf = 8;
	 */
	usePerf: boolean;

	/**
	 * Per-link path suffixes
	 *
	 * @generated from field: repeated string path_suffixes = 9;
	 */
	pathSuffixes: string[];

	/**
	 * @generated from field: repeated codes.v3.Identity identities = 10;
	 */
	identities: Identity[];
};

/**
 * @generated from message links.v1.BatchCreateLinksRequest
 */
export type BatchCreateLinksRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: optional string domain_id = 2;
	 */
	domainId?: string;

	/**
	 * @generated from field: repeated string urls = 3;
	 */
	urls?: string[];

	/**
	 * @generated from field: repeated string hashes = 7;
	 */
	hashes?: string[];

	/**
	 * @generated from field: string workspace_id = 4 [deprecated = true];
	 * @deprecated
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string batch_id = 5;
	 */
	batchId?: string;

	/**
	 * @generated from field: string path_suffix = 6;
	 */
	pathSuffix?: string;

	/**
	 * @generated from field: bool use_perf = 8;
	 */
	usePerf?: boolean;

	/**
	 * Per-link path suffixes
	 *
	 * @generated from field: repeated string path_suffixes = 9;
	 */
	pathSuffixes?: string[];

	/**
	 * @generated from field: repeated codes.v3.Identity identities = 10;
	 */
	identities?: IdentityJson[];
};

/**
 * Describes the message links.v1.BatchCreateLinksRequest.
 * Use `create(BatchCreateLinksRequestSchema)` to create a new message.
 */
export const BatchCreateLinksRequestSchema: GenMessage<BatchCreateLinksRequest, { jsonType: BatchCreateLinksRequestJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 7);

/**
 * @generated from message links.v1.BatchCreateLinksResponse
 */
export type BatchCreateLinksResponse = Message<"links.v1.BatchCreateLinksResponse"> & {
	/**
	 * @generated from field: repeated links.v1.CreateLinkResponse items = 1;
	 */
	items: CreateLinkResponse[];
};

/**
 * @generated from message links.v1.BatchCreateLinksResponse
 */
export type BatchCreateLinksResponseJson = {
	/**
	 * @generated from field: repeated links.v1.CreateLinkResponse items = 1;
	 */
	items?: CreateLinkResponseJson[];
};

/**
 * Describes the message links.v1.BatchCreateLinksResponse.
 * Use `create(BatchCreateLinksResponseSchema)` to create a new message.
 */
export const BatchCreateLinksResponseSchema: GenMessage<BatchCreateLinksResponse, { jsonType: BatchCreateLinksResponseJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 8);

/**
 * @generated from message links.v1.CreateDomainRequest
 */
export type CreateDomainRequest = Message<"links.v1.CreateDomainRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string domain = 2;
	 */
	domain: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description: string;

	/**
	 * @generated from field: bool custom_hostname = 5;
	 */
	customHostname: boolean;

	/**
	 * @generated from field: bool workspace_default = 6;
	 */
	workspaceDefault: boolean;

	/**
	 * @generated from field: bool org_default = 7;
	 */
	orgDefault: boolean;

	/**
	 * @generated from field: links.v1.DomainStatus status = 8;
	 */
	status: DomainStatus;

	/**
	 * @generated from field: bool global_default = 9;
	 */
	globalDefault: boolean;
};

/**
 * @generated from message links.v1.CreateDomainRequest
 */
export type CreateDomainRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string domain = 2;
	 */
	domain?: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description?: string;

	/**
	 * @generated from field: bool custom_hostname = 5;
	 */
	customHostname?: boolean;

	/**
	 * @generated from field: bool workspace_default = 6;
	 */
	workspaceDefault?: boolean;

	/**
	 * @generated from field: bool org_default = 7;
	 */
	orgDefault?: boolean;

	/**
	 * @generated from field: links.v1.DomainStatus status = 8;
	 */
	status?: DomainStatusJson;

	/**
	 * @generated from field: bool global_default = 9;
	 */
	globalDefault?: boolean;
};

/**
 * Describes the message links.v1.CreateDomainRequest.
 * Use `create(CreateDomainRequestSchema)` to create a new message.
 */
export const CreateDomainRequestSchema: GenMessage<CreateDomainRequest, { jsonType: CreateDomainRequestJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 9);

/**
 * @generated from message links.v1.CreateDomainResponse
 */
export type CreateDomainResponse = Message<"links.v1.CreateDomainResponse"> & {
	/**
	 * @generated from field: links.v1.Domain item = 1;
	 */
	item?: Domain | undefined;
};

/**
 * @generated from message links.v1.CreateDomainResponse
 */
export type CreateDomainResponseJson = {
	/**
	 * @generated from field: links.v1.Domain item = 1;
	 */
	item?: DomainJson;
};

/**
 * Describes the message links.v1.CreateDomainResponse.
 * Use `create(CreateDomainResponseSchema)` to create a new message.
 */
export const CreateDomainResponseSchema: GenMessage<CreateDomainResponse, { jsonType: CreateDomainResponseJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 10);

/**
 * @generated from message links.v1.GetLinkRequest
 */
export type GetLinkRequest = Message<"links.v1.GetLinkRequest"> & {
	/**
	 * @generated from field: string hash = 1;
	 */
	hash: string;

	/**
	 * @generated from field: string domain_id = 2;
	 */
	domainId: string;
};

/**
 * @generated from message links.v1.GetLinkRequest
 */
export type GetLinkRequestJson = {
	/**
	 * @generated from field: string hash = 1;
	 */
	hash?: string;

	/**
	 * @generated from field: string domain_id = 2;
	 */
	domainId?: string;
};

/**
 * Describes the message links.v1.GetLinkRequest.
 * Use `create(GetLinkRequestSchema)` to create a new message.
 */
export const GetLinkRequestSchema: GenMessage<GetLinkRequest, { jsonType: GetLinkRequestJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 11);

/**
 * @generated from message links.v1.GetLinkResponse
 */
export type GetLinkResponse = Message<"links.v1.GetLinkResponse"> & {
	/**
	 * @generated from field: string short = 1;
	 */
	short: string;

	/**
	 * @generated from field: string original = 2;
	 */
	original: string;
};

/**
 * @generated from message links.v1.GetLinkResponse
 */
export type GetLinkResponseJson = {
	/**
	 * @generated from field: string short = 1;
	 */
	short?: string;

	/**
	 * @generated from field: string original = 2;
	 */
	original?: string;
};

/**
 * Describes the message links.v1.GetLinkResponse.
 * Use `create(GetLinkResponseSchema)` to create a new message.
 */
export const GetLinkResponseSchema: GenMessage<GetLinkResponse, { jsonType: GetLinkResponseJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 12);

/**
 * @generated from message links.v1.DeleteLinkRequest
 */
export type DeleteLinkRequest = Message<"links.v1.DeleteLinkRequest"> & {
	/**
	 * @generated from field: string hash = 1;
	 */
	hash: string;

	/**
	 * @generated from field: string workspace_id = 2 [deprecated = true];
	 * @deprecated
	 */
	workspaceId: string;

	/**
	 * @generated from field: string domain_id = 3;
	 */
	domainId: string;
};

/**
 * @generated from message links.v1.DeleteLinkRequest
 */
export type DeleteLinkRequestJson = {
	/**
	 * @generated from field: string hash = 1;
	 */
	hash?: string;

	/**
	 * @generated from field: string workspace_id = 2 [deprecated = true];
	 * @deprecated
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string domain_id = 3;
	 */
	domainId?: string;
};

/**
 * Describes the message links.v1.DeleteLinkRequest.
 * Use `create(DeleteLinkRequestSchema)` to create a new message.
 */
export const DeleteLinkRequestSchema: GenMessage<DeleteLinkRequest, { jsonType: DeleteLinkRequestJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 13);

/**
 * @generated from message links.v1.DeleteLinkResponse
 */
export type DeleteLinkResponse = Message<"links.v1.DeleteLinkResponse"> & {};

/**
 * @generated from message links.v1.DeleteLinkResponse
 */
export type DeleteLinkResponseJson = {};

/**
 * Describes the message links.v1.DeleteLinkResponse.
 * Use `create(DeleteLinkResponseSchema)` to create a new message.
 */
export const DeleteLinkResponseSchema: GenMessage<DeleteLinkResponse, { jsonType: DeleteLinkResponseJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 14);

/**
 * @generated from message links.v1.DeleteDomainRequest
 */
export type DeleteDomainRequest = Message<"links.v1.DeleteDomainRequest"> & {
	/**
	 * @generated from field: string domain_id = 1;
	 */
	domainId: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;
};

/**
 * @generated from message links.v1.DeleteDomainRequest
 */
export type DeleteDomainRequestJson = {
	/**
	 * @generated from field: string domain_id = 1;
	 */
	domainId?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;
};

/**
 * Describes the message links.v1.DeleteDomainRequest.
 * Use `create(DeleteDomainRequestSchema)` to create a new message.
 */
export const DeleteDomainRequestSchema: GenMessage<DeleteDomainRequest, { jsonType: DeleteDomainRequestJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 15);

/**
 * @generated from message links.v1.DeleteDomainResponse
 */
export type DeleteDomainResponse = Message<"links.v1.DeleteDomainResponse"> & {};

/**
 * @generated from message links.v1.DeleteDomainResponse
 */
export type DeleteDomainResponseJson = {};

/**
 * Describes the message links.v1.DeleteDomainResponse.
 * Use `create(DeleteDomainResponseSchema)` to create a new message.
 */
export const DeleteDomainResponseSchema: GenMessage<DeleteDomainResponse, { jsonType: DeleteDomainResponseJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 16);

/**
 * @generated from message links.v1.GetDomainRequest
 */
export type GetDomainRequest = Message<"links.v1.GetDomainRequest"> & {
	/**
	 * @generated from field: string domain_id = 1;
	 */
	domainId: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;
};

/**
 * @generated from message links.v1.GetDomainRequest
 */
export type GetDomainRequestJson = {
	/**
	 * @generated from field: string domain_id = 1;
	 */
	domainId?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;
};

/**
 * Describes the message links.v1.GetDomainRequest.
 * Use `create(GetDomainRequestSchema)` to create a new message.
 */
export const GetDomainRequestSchema: GenMessage<GetDomainRequest, { jsonType: GetDomainRequestJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 17);

/**
 * @generated from message links.v1.GetDomainResponse
 */
export type GetDomainResponse = Message<"links.v1.GetDomainResponse"> & {
	/**
	 * @generated from field: links.v1.Domain item = 1;
	 */
	item?: Domain | undefined;
};

/**
 * @generated from message links.v1.GetDomainResponse
 */
export type GetDomainResponseJson = {
	/**
	 * @generated from field: links.v1.Domain item = 1;
	 */
	item?: DomainJson;
};

/**
 * Describes the message links.v1.GetDomainResponse.
 * Use `create(GetDomainResponseSchema)` to create a new message.
 */
export const GetDomainResponseSchema: GenMessage<GetDomainResponse, { jsonType: GetDomainResponseJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 18);

/**
 * @generated from message links.v1.GetDomainOneTrustIDRequest
 */
export type GetDomainOneTrustIDRequest = Message<"links.v1.GetDomainOneTrustIDRequest"> & {
	/**
	 * @generated from field: string domain_id = 1;
	 */
	domainId: string;
};

/**
 * @generated from message links.v1.GetDomainOneTrustIDRequest
 */
export type GetDomainOneTrustIDRequestJson = {
	/**
	 * @generated from field: string domain_id = 1;
	 */
	domainId?: string;
};

/**
 * Describes the message links.v1.GetDomainOneTrustIDRequest.
 * Use `create(GetDomainOneTrustIDRequestSchema)` to create a new message.
 */
export const GetDomainOneTrustIDRequestSchema: GenMessage<GetDomainOneTrustIDRequest, { jsonType: GetDomainOneTrustIDRequestJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 19);

/**
 * @generated from message links.v1.GetDomainOneTrustIDResponse
 */
export type GetDomainOneTrustIDResponse = Message<"links.v1.GetDomainOneTrustIDResponse"> & {
	/**
	 * @generated from field: string one_trust_id = 1;
	 */
	oneTrustId: string;

	/**
	 * @generated from field: string domain = 2;
	 */
	domain: string;

	/**
	 * @generated from field: string privacy_policy_link_hash = 3;
	 */
	privacyPolicyLinkHash: string;

	/**
	 * @generated from field: string cookie_preferences_link_label = 4;
	 */
	cookiePreferencesLinkLabel: string;

	/**
	 * @generated from field: string do_not_sell_policy_link_url = 5;
	 */
	doNotSellPolicyLinkUrl: string;

	/**
	 * @generated from field: string do_not_sell_policy_link_label = 6;
	 */
	doNotSellPolicyLinkLabel: string;

	/**
	 * @generated from field: string privacy_preferences_url = 7;
	 */
	privacyPreferencesUrl: string;

	/**
	 * @generated from field: string privacy_preferences_label = 8;
	 */
	privacyPreferencesLabel: string;

	/**
	 * @generated from field: string privacy_smile_url = 9;
	 */
	privacySmileUrl: string;
};

/**
 * @generated from message links.v1.GetDomainOneTrustIDResponse
 */
export type GetDomainOneTrustIDResponseJson = {
	/**
	 * @generated from field: string one_trust_id = 1;
	 */
	oneTrustId?: string;

	/**
	 * @generated from field: string domain = 2;
	 */
	domain?: string;

	/**
	 * @generated from field: string privacy_policy_link_hash = 3;
	 */
	privacyPolicyLinkHash?: string;

	/**
	 * @generated from field: string cookie_preferences_link_label = 4;
	 */
	cookiePreferencesLinkLabel?: string;

	/**
	 * @generated from field: string do_not_sell_policy_link_url = 5;
	 */
	doNotSellPolicyLinkUrl?: string;

	/**
	 * @generated from field: string do_not_sell_policy_link_label = 6;
	 */
	doNotSellPolicyLinkLabel?: string;

	/**
	 * @generated from field: string privacy_preferences_url = 7;
	 */
	privacyPreferencesUrl?: string;

	/**
	 * @generated from field: string privacy_preferences_label = 8;
	 */
	privacyPreferencesLabel?: string;

	/**
	 * @generated from field: string privacy_smile_url = 9;
	 */
	privacySmileUrl?: string;
};

/**
 * Describes the message links.v1.GetDomainOneTrustIDResponse.
 * Use `create(GetDomainOneTrustIDResponseSchema)` to create a new message.
 */
export const GetDomainOneTrustIDResponseSchema: GenMessage<GetDomainOneTrustIDResponse, { jsonType: GetDomainOneTrustIDResponseJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 20);

/**
 * @generated from message links.v1.GetDomainPublicConfigRequest
 */
export type GetDomainPublicConfigRequest = Message<"links.v1.GetDomainPublicConfigRequest"> & {
	/**
	 * @generated from field: string domain_id = 1;
	 */
	domainId: string;
};

/**
 * @generated from message links.v1.GetDomainPublicConfigRequest
 */
export type GetDomainPublicConfigRequestJson = {
	/**
	 * @generated from field: string domain_id = 1;
	 */
	domainId?: string;
};

/**
 * Describes the message links.v1.GetDomainPublicConfigRequest.
 * Use `create(GetDomainPublicConfigRequestSchema)` to create a new message.
 */
export const GetDomainPublicConfigRequestSchema: GenMessage<GetDomainPublicConfigRequest, { jsonType: GetDomainPublicConfigRequestJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 21);

/**
 * @generated from message links.v1.GetDomainPublicConfigResponse
 */
export type GetDomainPublicConfigResponse = Message<"links.v1.GetDomainPublicConfigResponse"> & {
	/**
	 * @generated from field: string one_trust_id = 1;
	 */
	oneTrustId: string;

	/**
	 * @generated from field: string domain = 2;
	 */
	domain: string;

	/**
	 * @generated from field: string privacy_policy_link_hash = 3;
	 */
	privacyPolicyLinkHash: string;

	/**
	 * @generated from field: string cookie_preferences_link_label = 4;
	 */
	cookiePreferencesLinkLabel: string;

	/**
	 * @generated from field: string do_not_sell_policy_link_url = 5;
	 */
	doNotSellPolicyLinkUrl: string;

	/**
	 * @generated from field: string do_not_sell_policy_link_label = 6;
	 */
	doNotSellPolicyLinkLabel: string;

	/**
	 * @generated from field: string privacy_preferences_url = 7;
	 */
	privacyPreferencesUrl: string;

	/**
	 * @generated from field: string privacy_preferences_label = 8;
	 */
	privacyPreferencesLabel: string;

	/**
	 * @generated from field: string privacy_smile_url = 9;
	 */
	privacySmileUrl: string;

	/**
	 * true = Flowcode global default domain; false = custom domain.
	 *
	 * @generated from field: bool is_global_default = 10;
	 */
	isGlobalDefault: boolean;

	/**
	 * Ordered footer privacy links, both predefined references and custom, with order implied by position.
	 *
	 * @generated from field: repeated links.v1.PrivacyLink privacy_links = 11;
	 */
	privacyLinks: PrivacyLink[];

	/**
	 * @generated from field: string privacy_policy_link_label = 12;
	 */
	privacyPolicyLinkLabel: string;
};

/**
 * @generated from message links.v1.GetDomainPublicConfigResponse
 */
export type GetDomainPublicConfigResponseJson = {
	/**
	 * @generated from field: string one_trust_id = 1;
	 */
	oneTrustId?: string;

	/**
	 * @generated from field: string domain = 2;
	 */
	domain?: string;

	/**
	 * @generated from field: string privacy_policy_link_hash = 3;
	 */
	privacyPolicyLinkHash?: string;

	/**
	 * @generated from field: string cookie_preferences_link_label = 4;
	 */
	cookiePreferencesLinkLabel?: string;

	/**
	 * @generated from field: string do_not_sell_policy_link_url = 5;
	 */
	doNotSellPolicyLinkUrl?: string;

	/**
	 * @generated from field: string do_not_sell_policy_link_label = 6;
	 */
	doNotSellPolicyLinkLabel?: string;

	/**
	 * @generated from field: string privacy_preferences_url = 7;
	 */
	privacyPreferencesUrl?: string;

	/**
	 * @generated from field: string privacy_preferences_label = 8;
	 */
	privacyPreferencesLabel?: string;

	/**
	 * @generated from field: string privacy_smile_url = 9;
	 */
	privacySmileUrl?: string;

	/**
	 * true = Flowcode global default domain; false = custom domain.
	 *
	 * @generated from field: bool is_global_default = 10;
	 */
	isGlobalDefault?: boolean;

	/**
	 * Ordered footer privacy links, both predefined references and custom, with order implied by position.
	 *
	 * @generated from field: repeated links.v1.PrivacyLink privacy_links = 11;
	 */
	privacyLinks?: PrivacyLinkJson[];

	/**
	 * @generated from field: string privacy_policy_link_label = 12;
	 */
	privacyPolicyLinkLabel?: string;
};

/**
 * Describes the message links.v1.GetDomainPublicConfigResponse.
 * Use `create(GetDomainPublicConfigResponseSchema)` to create a new message.
 */
export const GetDomainPublicConfigResponseSchema: GenMessage<GetDomainPublicConfigResponse, { jsonType: GetDomainPublicConfigResponseJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 22);

/**
 * @generated from message links.v1.GetDomainOneTrustConfigsRequest
 */
export type GetDomainOneTrustConfigsRequest = Message<"links.v1.GetDomainOneTrustConfigsRequest"> & {
	/**
	 * @generated from field: repeated string domain_ids = 1;
	 */
	domainIds: string[];
};

/**
 * @generated from message links.v1.GetDomainOneTrustConfigsRequest
 */
export type GetDomainOneTrustConfigsRequestJson = {
	/**
	 * @generated from field: repeated string domain_ids = 1;
	 */
	domainIds?: string[];
};

/**
 * Describes the message links.v1.GetDomainOneTrustConfigsRequest.
 * Use `create(GetDomainOneTrustConfigsRequestSchema)` to create a new message.
 */
export const GetDomainOneTrustConfigsRequestSchema: GenMessage<GetDomainOneTrustConfigsRequest, { jsonType: GetDomainOneTrustConfigsRequestJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 23);

/**
 * @generated from message links.v1.GetDomainOneTrustConfigsResponse
 */
export type GetDomainOneTrustConfigsResponse = Message<"links.v1.GetDomainOneTrustConfigsResponse"> & {
	/**
	 * @generated from field: repeated links.v1.DomainOneTrustConfig items = 1;
	 */
	items: DomainOneTrustConfig[];
};

/**
 * @generated from message links.v1.GetDomainOneTrustConfigsResponse
 */
export type GetDomainOneTrustConfigsResponseJson = {
	/**
	 * @generated from field: repeated links.v1.DomainOneTrustConfig items = 1;
	 */
	items?: DomainOneTrustConfigJson[];
};

/**
 * Describes the message links.v1.GetDomainOneTrustConfigsResponse.
 * Use `create(GetDomainOneTrustConfigsResponseSchema)` to create a new message.
 */
export const GetDomainOneTrustConfigsResponseSchema: GenMessage<GetDomainOneTrustConfigsResponse, { jsonType: GetDomainOneTrustConfigsResponseJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 24);

/**
 * @generated from message links.v1.DomainOneTrustConfig
 */
export type DomainOneTrustConfig = Message<"links.v1.DomainOneTrustConfig"> & {
	/**
	 * @generated from field: string domain_id = 1;
	 */
	domainId: string;

	/**
	 * @generated from field: string one_trust_id = 2;
	 */
	oneTrustId: string;

	/**
	 * @generated from field: string domain = 3;
	 */
	domain: string;

	/**
	 * @generated from field: string privacy_policy_link_hash = 4;
	 */
	privacyPolicyLinkHash: string;

	/**
	 * @generated from field: string cookie_preferences_link_label = 5;
	 */
	cookiePreferencesLinkLabel: string;

	/**
	 * @generated from field: string do_not_sell_policy_link_url = 6;
	 */
	doNotSellPolicyLinkUrl: string;

	/**
	 * @generated from field: string do_not_sell_policy_link_label = 7;
	 */
	doNotSellPolicyLinkLabel: string;

	/**
	 * @generated from field: string privacy_preferences_url = 8;
	 */
	privacyPreferencesUrl: string;

	/**
	 * @generated from field: string privacy_preferences_label = 9;
	 */
	privacyPreferencesLabel: string;

	/**
	 * @generated from field: string privacy_smile_url = 10;
	 */
	privacySmileUrl: string;
};

/**
 * @generated from message links.v1.DomainOneTrustConfig
 */
export type DomainOneTrustConfigJson = {
	/**
	 * @generated from field: string domain_id = 1;
	 */
	domainId?: string;

	/**
	 * @generated from field: string one_trust_id = 2;
	 */
	oneTrustId?: string;

	/**
	 * @generated from field: string domain = 3;
	 */
	domain?: string;

	/**
	 * @generated from field: string privacy_policy_link_hash = 4;
	 */
	privacyPolicyLinkHash?: string;

	/**
	 * @generated from field: string cookie_preferences_link_label = 5;
	 */
	cookiePreferencesLinkLabel?: string;

	/**
	 * @generated from field: string do_not_sell_policy_link_url = 6;
	 */
	doNotSellPolicyLinkUrl?: string;

	/**
	 * @generated from field: string do_not_sell_policy_link_label = 7;
	 */
	doNotSellPolicyLinkLabel?: string;

	/**
	 * @generated from field: string privacy_preferences_url = 8;
	 */
	privacyPreferencesUrl?: string;

	/**
	 * @generated from field: string privacy_preferences_label = 9;
	 */
	privacyPreferencesLabel?: string;

	/**
	 * @generated from field: string privacy_smile_url = 10;
	 */
	privacySmileUrl?: string;
};

/**
 * Describes the message links.v1.DomainOneTrustConfig.
 * Use `create(DomainOneTrustConfigSchema)` to create a new message.
 */
export const DomainOneTrustConfigSchema: GenMessage<DomainOneTrustConfig, { jsonType: DomainOneTrustConfigJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 25);

/**
 * @generated from message links.v1.GetDefaultDomainRequest
 */
export type GetDefaultDomainRequest = Message<"links.v1.GetDefaultDomainRequest"> & {
	/**
	 * @generated from field: string workspace_id = 1;
	 */
	workspaceId: string;
};

/**
 * @generated from message links.v1.GetDefaultDomainRequest
 */
export type GetDefaultDomainRequestJson = {
	/**
	 * @generated from field: string workspace_id = 1;
	 */
	workspaceId?: string;
};

/**
 * Describes the message links.v1.GetDefaultDomainRequest.
 * Use `create(GetDefaultDomainRequestSchema)` to create a new message.
 */
export const GetDefaultDomainRequestSchema: GenMessage<GetDefaultDomainRequest, { jsonType: GetDefaultDomainRequestJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 26);

/**
 * @generated from message links.v1.GetDefaultDomainResponse
 */
export type GetDefaultDomainResponse = Message<"links.v1.GetDefaultDomainResponse"> & {
	/**
	 * @generated from field: links.v1.Domain item = 1;
	 */
	item?: Domain | undefined;
};

/**
 * @generated from message links.v1.GetDefaultDomainResponse
 */
export type GetDefaultDomainResponseJson = {
	/**
	 * @generated from field: links.v1.Domain item = 1;
	 */
	item?: DomainJson;
};

/**
 * Describes the message links.v1.GetDefaultDomainResponse.
 * Use `create(GetDefaultDomainResponseSchema)` to create a new message.
 */
export const GetDefaultDomainResponseSchema: GenMessage<GetDefaultDomainResponse, { jsonType: GetDefaultDomainResponseJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 27);

/**
 * @generated from message links.v1.UpdateLinkRequest
 */
export type UpdateLinkRequest = Message<"links.v1.UpdateLinkRequest"> & {
	/**
	 * @generated from field: string hash = 1;
	 */
	hash: string;

	/**
	 * @generated from field: string url = 2;
	 */
	url: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId: string;

	/**
	 * @generated from field: string domain_id = 4;
	 */
	domainId: string;

	/**
	 * @generated from field: string workspace_id = 5 [deprecated = true];
	 * @deprecated
	 */
	workspaceId: string;

	/**
	 * @generated from field: string batch_id = 6;
	 */
	batchId: string;

	/**
	 * @generated from field: string path_suffix = 7;
	 */
	pathSuffix: string;
};

/**
 * @generated from message links.v1.UpdateLinkRequest
 */
export type UpdateLinkRequestJson = {
	/**
	 * @generated from field: string hash = 1;
	 */
	hash?: string;

	/**
	 * @generated from field: string url = 2;
	 */
	url?: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId?: string;

	/**
	 * @generated from field: string domain_id = 4;
	 */
	domainId?: string;

	/**
	 * @generated from field: string workspace_id = 5 [deprecated = true];
	 * @deprecated
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string batch_id = 6;
	 */
	batchId?: string;

	/**
	 * @generated from field: string path_suffix = 7;
	 */
	pathSuffix?: string;
};

/**
 * Describes the message links.v1.UpdateLinkRequest.
 * Use `create(UpdateLinkRequestSchema)` to create a new message.
 */
export const UpdateLinkRequestSchema: GenMessage<UpdateLinkRequest, { jsonType: UpdateLinkRequestJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 28);

/**
 * @generated from message links.v1.UpdateLinkResponse
 */
export type UpdateLinkResponse = Message<"links.v1.UpdateLinkResponse"> & {
	/**
	 * @generated from field: links.v1.Link item = 1;
	 */
	item?: Link | undefined;
};

/**
 * @generated from message links.v1.UpdateLinkResponse
 */
export type UpdateLinkResponseJson = {
	/**
	 * @generated from field: links.v1.Link item = 1;
	 */
	item?: LinkJson;
};

/**
 * Describes the message links.v1.UpdateLinkResponse.
 * Use `create(UpdateLinkResponseSchema)` to create a new message.
 */
export const UpdateLinkResponseSchema: GenMessage<UpdateLinkResponse, { jsonType: UpdateLinkResponseJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 29);

/**
 * @generated from message links.v1.UpdateLinkBatchRequest
 */
export type UpdateLinkBatchRequest = Message<"links.v1.UpdateLinkBatchRequest"> & {
	/**
	 * @generated from field: string batch_id = 1;
	 */
	batchId: string;

	/**
	 * @generated from field: string domain_id = 2;
	 */
	domainId: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId: string;

	/**
	 * @generated from field: optional string path_suffix = 4;
	 */
	pathSuffix?: string | undefined;
};

/**
 * @generated from message links.v1.UpdateLinkBatchRequest
 */
export type UpdateLinkBatchRequestJson = {
	/**
	 * @generated from field: string batch_id = 1;
	 */
	batchId?: string;

	/**
	 * @generated from field: string domain_id = 2;
	 */
	domainId?: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: optional string path_suffix = 4;
	 */
	pathSuffix?: string;
};

/**
 * Describes the message links.v1.UpdateLinkBatchRequest.
 * Use `create(UpdateLinkBatchRequestSchema)` to create a new message.
 */
export const UpdateLinkBatchRequestSchema: GenMessage<UpdateLinkBatchRequest, { jsonType: UpdateLinkBatchRequestJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 30);

/**
 * @generated from message links.v1.UpdateLinkBatchResponse
 */
export type UpdateLinkBatchResponse = Message<"links.v1.UpdateLinkBatchResponse"> & {
	/**
	 * @generated from field: string batch_id = 1;
	 */
	batchId: string;

	/**
	 * @generated from field: links.v1.Domain domain = 2;
	 */
	domain?: Domain | undefined;
};

/**
 * @generated from message links.v1.UpdateLinkBatchResponse
 */
export type UpdateLinkBatchResponseJson = {
	/**
	 * @generated from field: string batch_id = 1;
	 */
	batchId?: string;

	/**
	 * @generated from field: links.v1.Domain domain = 2;
	 */
	domain?: DomainJson;
};

/**
 * Describes the message links.v1.UpdateLinkBatchResponse.
 * Use `create(UpdateLinkBatchResponseSchema)` to create a new message.
 */
export const UpdateLinkBatchResponseSchema: GenMessage<UpdateLinkBatchResponse, { jsonType: UpdateLinkBatchResponseJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 31);

/**
 * @generated from message links.v1.UpdateDomainRequest
 */
export type UpdateDomainRequest = Message<"links.v1.UpdateDomainRequest"> & {
	/**
	 * @generated from field: string domain_id = 1;
	 */
	domainId: string;

	/**
	 * @generated from field: string domain = 2;
	 */
	domain: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description: string;

	/**
	 * @generated from field: string workspace_id = 6;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string one_trust_id = 7;
	 */
	oneTrustId: string;

	/**
	 * @generated from field: string privacy_policy_link_hash = 8;
	 */
	privacyPolicyLinkHash: string;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 9;
	 */
	mask?: FieldMask | undefined;

	/**
	 * @generated from field: string cookie_preferences_link_label = 10;
	 */
	cookiePreferencesLinkLabel: string;

	/**
	 * @generated from field: string do_not_sell_policy_link_url = 11;
	 */
	doNotSellPolicyLinkUrl: string;

	/**
	 * @generated from field: string do_not_sell_policy_link_label = 12;
	 */
	doNotSellPolicyLinkLabel: string;

	/**
	 * @generated from field: string privacy_preferences_url = 13;
	 */
	privacyPreferencesUrl: string;

	/**
	 * @generated from field: string privacy_preferences_label = 14;
	 */
	privacyPreferencesLabel: string;

	/**
	 * @generated from field: string fallback_redirect_url = 15;
	 */
	fallbackRedirectUrl: string;

	/**
	 * @generated from field: string privacy_smile_url = 16;
	 */
	privacySmileUrl: string;

	/**
	 * Ordered footer privacy links, both predefined references and custom. Update it
	 * with the "privacy_links" mask path, which replaces the whole array.
	 *
	 * @generated from field: repeated links.v1.PrivacyLink privacy_links = 17;
	 */
	privacyLinks: PrivacyLink[];

	/**
	 * @generated from field: string privacy_policy_link_label = 18;
	 */
	privacyPolicyLinkLabel: string;
};

/**
 * @generated from message links.v1.UpdateDomainRequest
 */
export type UpdateDomainRequestJson = {
	/**
	 * @generated from field: string domain_id = 1;
	 */
	domainId?: string;

	/**
	 * @generated from field: string domain = 2;
	 */
	domain?: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId?: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description?: string;

	/**
	 * @generated from field: string workspace_id = 6;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string one_trust_id = 7;
	 */
	oneTrustId?: string;

	/**
	 * @generated from field: string privacy_policy_link_hash = 8;
	 */
	privacyPolicyLinkHash?: string;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 9;
	 */
	mask?: FieldMaskJson;

	/**
	 * @generated from field: string cookie_preferences_link_label = 10;
	 */
	cookiePreferencesLinkLabel?: string;

	/**
	 * @generated from field: string do_not_sell_policy_link_url = 11;
	 */
	doNotSellPolicyLinkUrl?: string;

	/**
	 * @generated from field: string do_not_sell_policy_link_label = 12;
	 */
	doNotSellPolicyLinkLabel?: string;

	/**
	 * @generated from field: string privacy_preferences_url = 13;
	 */
	privacyPreferencesUrl?: string;

	/**
	 * @generated from field: string privacy_preferences_label = 14;
	 */
	privacyPreferencesLabel?: string;

	/**
	 * @generated from field: string fallback_redirect_url = 15;
	 */
	fallbackRedirectUrl?: string;

	/**
	 * @generated from field: string privacy_smile_url = 16;
	 */
	privacySmileUrl?: string;

	/**
	 * Ordered footer privacy links, both predefined references and custom. Update it
	 * with the "privacy_links" mask path, which replaces the whole array.
	 *
	 * @generated from field: repeated links.v1.PrivacyLink privacy_links = 17;
	 */
	privacyLinks?: PrivacyLinkJson[];

	/**
	 * @generated from field: string privacy_policy_link_label = 18;
	 */
	privacyPolicyLinkLabel?: string;
};

/**
 * Describes the message links.v1.UpdateDomainRequest.
 * Use `create(UpdateDomainRequestSchema)` to create a new message.
 */
export const UpdateDomainRequestSchema: GenMessage<UpdateDomainRequest, { jsonType: UpdateDomainRequestJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 32);

/**
 * @generated from message links.v1.UpdateDomainResponse
 */
export type UpdateDomainResponse = Message<"links.v1.UpdateDomainResponse"> & {
	/**
	 * @generated from field: links.v1.Domain item = 1;
	 */
	item?: Domain | undefined;
};

/**
 * @generated from message links.v1.UpdateDomainResponse
 */
export type UpdateDomainResponseJson = {
	/**
	 * @generated from field: links.v1.Domain item = 1;
	 */
	item?: DomainJson;
};

/**
 * Describes the message links.v1.UpdateDomainResponse.
 * Use `create(UpdateDomainResponseSchema)` to create a new message.
 */
export const UpdateDomainResponseSchema: GenMessage<UpdateDomainResponse, { jsonType: UpdateDomainResponseJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 33);

/**
 * @generated from message links.v1.DomainFilter
 */
export type DomainFilter = Message<"links.v1.DomainFilter"> & {
	/**
	 * @generated from field: optional string domain = 1;
	 */
	domain?: string | undefined;

	/**
	 * @generated from field: optional links.v1.DomainStatus status = 2;
	 */
	status?: DomainStatus | undefined;

	/**
	 * @generated from field: optional bool has_one_trust_id = 3;
	 */
	hasOneTrustId?: boolean | undefined;

	/**
	 * @generated from field: optional bool is_dpa_compliant = 4;
	 */
	isDpaCompliant?: boolean | undefined;
};

/**
 * @generated from message links.v1.DomainFilter
 */
export type DomainFilterJson = {
	/**
	 * @generated from field: optional string domain = 1;
	 */
	domain?: string;

	/**
	 * @generated from field: optional links.v1.DomainStatus status = 2;
	 */
	status?: DomainStatusJson;

	/**
	 * @generated from field: optional bool has_one_trust_id = 3;
	 */
	hasOneTrustId?: boolean;

	/**
	 * @generated from field: optional bool is_dpa_compliant = 4;
	 */
	isDpaCompliant?: boolean;
};

/**
 * Describes the message links.v1.DomainFilter.
 * Use `create(DomainFilterSchema)` to create a new message.
 */
export const DomainFilterSchema: GenMessage<DomainFilter, { jsonType: DomainFilterJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 34);

/**
 * @generated from message links.v1.ListDomainsRequest
 */
export type ListDomainsRequest = Message<"links.v1.ListDomainsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: links.v1.DomainFilter filter = 4;
	 */
	filter?: DomainFilter | undefined;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 3;
	 */
	paginate?: PaginationArguments | undefined;
};

/**
 * @generated from message links.v1.ListDomainsRequest
 */
export type ListDomainsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: links.v1.DomainFilter filter = 4;
	 */
	filter?: DomainFilterJson;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 3;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message links.v1.ListDomainsRequest.
 * Use `create(ListDomainsRequestSchema)` to create a new message.
 */
export const ListDomainsRequestSchema: GenMessage<ListDomainsRequest, { jsonType: ListDomainsRequestJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 35);

/**
 * @generated from message links.v1.ListDomainsResponse
 */
export type ListDomainsResponse = Message<"links.v1.ListDomainsResponse"> & {
	/**
	 * @generated from field: repeated links.v1.Domain items = 1;
	 */
	items: Domain[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message links.v1.ListDomainsResponse
 */
export type ListDomainsResponseJson = {
	/**
	 * @generated from field: repeated links.v1.Domain items = 1;
	 */
	items?: DomainJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message links.v1.ListDomainsResponse.
 * Use `create(ListDomainsResponseSchema)` to create a new message.
 */
export const ListDomainsResponseSchema: GenMessage<ListDomainsResponse, { jsonType: ListDomainsResponseJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 36);

/**
 * @generated from message links.v1.RedirectRequest
 */
export type RedirectRequest = Message<"links.v1.RedirectRequest"> & {
	/**
	 * @generated from field: string hash = 1;
	 */
	hash: string;

	/**
	 * When the path is pulled from the http gateway path parameters, any leading slash will have been removed.
	 *
	 * @generated from field: string path = 2;
	 */
	path: string;

	/**
	 * An optional host name to resolve against
	 *
	 * @generated from field: optional string host = 3;
	 */
	host?: string | undefined;
};

/**
 * @generated from message links.v1.RedirectRequest
 */
export type RedirectRequestJson = {
	/**
	 * @generated from field: string hash = 1;
	 */
	hash?: string;

	/**
	 * When the path is pulled from the http gateway path parameters, any leading slash will have been removed.
	 *
	 * @generated from field: string path = 2;
	 */
	path?: string;

	/**
	 * An optional host name to resolve against
	 *
	 * @generated from field: optional string host = 3;
	 */
	host?: string;
};

/**
 * Describes the message links.v1.RedirectRequest.
 * Use `create(RedirectRequestSchema)` to create a new message.
 */
export const RedirectRequestSchema: GenMessage<RedirectRequest, { jsonType: RedirectRequestJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 37);

/**
 * @generated from message links.v1.RedirectCampaignRequest
 */
export type RedirectCampaignRequest = Message<"links.v1.RedirectCampaignRequest"> & {
	/**
	 * @generated from field: string batch_id = 1;
	 */
	batchId: string;

	/**
	 * @generated from oneof links.v1.RedirectCampaignRequest.identifier
	 */
	identifier:
		| {
				/**
				 * @generated from field: string email = 2;
				 */
				value: string;
				case: "email";
		  }
		| {
				/**
				 * @generated from field: string phone = 3;
				 */
				value: string;
				case: "phone";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message links.v1.RedirectCampaignRequest
 */
export type RedirectCampaignRequestJson = {
	/**
	 * @generated from field: string batch_id = 1;
	 */
	batchId?: string;

	/**
	 * @generated from field: string email = 2;
	 */
	email?: string;

	/**
	 * @generated from field: string phone = 3;
	 */
	phone?: string;
};

/**
 * Describes the message links.v1.RedirectCampaignRequest.
 * Use `create(RedirectCampaignRequestSchema)` to create a new message.
 */
export const RedirectCampaignRequestSchema: GenMessage<RedirectCampaignRequest, { jsonType: RedirectCampaignRequestJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 38);

/**
 * @generated from message links.v1.RedirectResponse
 */
export type RedirectResponse = Message<"links.v1.RedirectResponse"> & {
	/**
	 * @generated from field: string redirect_url = 1;
	 */
	redirectUrl: string;
};

/**
 * @generated from message links.v1.RedirectResponse
 */
export type RedirectResponseJson = {
	/**
	 * @generated from field: string redirect_url = 1;
	 */
	redirectUrl?: string;
};

/**
 * Describes the message links.v1.RedirectResponse.
 * Use `create(RedirectResponseSchema)` to create a new message.
 */
export const RedirectResponseSchema: GenMessage<RedirectResponse, { jsonType: RedirectResponseJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 39);

/**
 * @generated from message links.v1.RedirectCampaignResponse
 */
export type RedirectCampaignResponse = Message<"links.v1.RedirectCampaignResponse"> & {
	/**
	 * @generated from field: string redirect_url = 1;
	 */
	redirectUrl: string;
};

/**
 * @generated from message links.v1.RedirectCampaignResponse
 */
export type RedirectCampaignResponseJson = {
	/**
	 * @generated from field: string redirect_url = 1;
	 */
	redirectUrl?: string;
};

/**
 * Describes the message links.v1.RedirectCampaignResponse.
 * Use `create(RedirectCampaignResponseSchema)` to create a new message.
 */
export const RedirectCampaignResponseSchema: GenMessage<RedirectCampaignResponse, { jsonType: RedirectCampaignResponseJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 40);

/**
 * @generated from message links.v1.SetWorkspaceDefaultRequest
 */
export type SetWorkspaceDefaultRequest = Message<"links.v1.SetWorkspaceDefaultRequest"> & {
	/**
	 * @generated from field: string domain_id = 1;
	 */
	domainId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: bool org_default = 3;
	 */
	orgDefault: boolean;
};

/**
 * @generated from message links.v1.SetWorkspaceDefaultRequest
 */
export type SetWorkspaceDefaultRequestJson = {
	/**
	 * @generated from field: string domain_id = 1;
	 */
	domainId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: bool org_default = 3;
	 */
	orgDefault?: boolean;
};

/**
 * Describes the message links.v1.SetWorkspaceDefaultRequest.
 * Use `create(SetWorkspaceDefaultRequestSchema)` to create a new message.
 */
export const SetWorkspaceDefaultRequestSchema: GenMessage<SetWorkspaceDefaultRequest, { jsonType: SetWorkspaceDefaultRequestJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 41);

/**
 * @generated from message links.v1.SetWorkspaceDefaultResponse
 */
export type SetWorkspaceDefaultResponse = Message<"links.v1.SetWorkspaceDefaultResponse"> & {
	/**
	 * @generated from field: links.v1.Domain item = 1;
	 */
	item?: Domain | undefined;
};

/**
 * @generated from message links.v1.SetWorkspaceDefaultResponse
 */
export type SetWorkspaceDefaultResponseJson = {
	/**
	 * @generated from field: links.v1.Domain item = 1;
	 */
	item?: DomainJson;
};

/**
 * Describes the message links.v1.SetWorkspaceDefaultResponse.
 * Use `create(SetWorkspaceDefaultResponseSchema)` to create a new message.
 */
export const SetWorkspaceDefaultResponseSchema: GenMessage<SetWorkspaceDefaultResponse, { jsonType: SetWorkspaceDefaultResponseJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 42);

/**
 * @generated from message links.v1.GenerateLinkRequest
 */
export type GenerateLinkRequest = Message<"links.v1.GenerateLinkRequest"> & {
	/**
	 * @generated from field: string url = 1;
	 */
	url: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: optional string domain_id = 3;
	 */
	domainId?: string | undefined;

	/**
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string batch_id = 5;
	 */
	batchId: string;

	/**
	 * @generated from field: string path_suffix = 6;
	 */
	pathSuffix: string;

	/**
	 * @generated from field: string hash = 7;
	 */
	hash: string;
};

/**
 * @generated from message links.v1.GenerateLinkRequest
 */
export type GenerateLinkRequestJson = {
	/**
	 * @generated from field: string url = 1;
	 */
	url?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: optional string domain_id = 3;
	 */
	domainId?: string;

	/**
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string batch_id = 5;
	 */
	batchId?: string;

	/**
	 * @generated from field: string path_suffix = 6;
	 */
	pathSuffix?: string;

	/**
	 * @generated from field: string hash = 7;
	 */
	hash?: string;
};

/**
 * Describes the message links.v1.GenerateLinkRequest.
 * Use `create(GenerateLinkRequestSchema)` to create a new message.
 */
export const GenerateLinkRequestSchema: GenMessage<GenerateLinkRequest, { jsonType: GenerateLinkRequestJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 43);

/**
 * @generated from message links.v1.GenerateLinkResponse
 */
export type GenerateLinkResponse = Message<"links.v1.GenerateLinkResponse"> & {
	/**
	 * @generated from field: string link = 1;
	 */
	link: string;

	/**
	 * @generated from field: string hash = 2;
	 */
	hash: string;

	/**
	 * @generated from field: string url = 3;
	 */
	url: string;

	/**
	 * @generated from field: string domain_id = 4;
	 */
	domainId: string;

	/**
	 * @generated from field: string batch_id = 5;
	 */
	batchId: string;

	/**
	 * @generated from field: string path_suffix = 6;
	 */
	pathSuffix: string;
};

/**
 * @generated from message links.v1.GenerateLinkResponse
 */
export type GenerateLinkResponseJson = {
	/**
	 * @generated from field: string link = 1;
	 */
	link?: string;

	/**
	 * @generated from field: string hash = 2;
	 */
	hash?: string;

	/**
	 * @generated from field: string url = 3;
	 */
	url?: string;

	/**
	 * @generated from field: string domain_id = 4;
	 */
	domainId?: string;

	/**
	 * @generated from field: string batch_id = 5;
	 */
	batchId?: string;

	/**
	 * @generated from field: string path_suffix = 6;
	 */
	pathSuffix?: string;
};

/**
 * Describes the message links.v1.GenerateLinkResponse.
 * Use `create(GenerateLinkResponseSchema)` to create a new message.
 */
export const GenerateLinkResponseSchema: GenMessage<GenerateLinkResponse, { jsonType: GenerateLinkResponseJson }> = /*@__PURE__*/ messageDesc(file_links_v1_links, 44);

/**
 * @generated from enum links.v1.DomainStatus
 */
export enum DomainStatus {
	/**
	 * @generated from enum value: DOMAIN_STATUS_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: DOMAIN_STATUS_ACTIVE = 1;
	 */
	ACTIVE = 1,

	/**
	 * @generated from enum value: DOMAIN_STATUS_BLOCKED = 2;
	 */
	BLOCKED = 2,

	/**
	 * @generated from enum value: DOMAIN_STATUS_MOVED = 3;
	 */
	MOVED = 3,

	/**
	 * @generated from enum value: DOMAIN_STATUS_PENDING = 4;
	 */
	PENDING = 4,

	/**
	 * @generated from enum value: DOMAIN_STATUS_DELETED = 5;
	 */
	DELETED = 5,
}

/**
 * @generated from enum links.v1.DomainStatus
 */
export type DomainStatusJson = "DOMAIN_STATUS_UNSPECIFIED" | "DOMAIN_STATUS_ACTIVE" | "DOMAIN_STATUS_BLOCKED" | "DOMAIN_STATUS_MOVED" | "DOMAIN_STATUS_PENDING" | "DOMAIN_STATUS_DELETED";

/**
 * Describes the enum links.v1.DomainStatus.
 */
export const DomainStatusSchema: GenEnum<DomainStatus, DomainStatusJson> = /*@__PURE__*/ enumDesc(file_links_v1_links, 0);

/**
 * @generated from service links.v1.LinksService
 */
export const LinksService: GenService<{
	/**
	 * @generated from rpc links.v1.LinksService.CreateLink
	 */
	createLink: {
		methodKind: "unary";
		input: typeof CreateLinkRequestSchema;
		output: typeof CreateLinkResponseSchema;
	};
	/**
	 * @generated from rpc links.v1.LinksService.BatchCreateLinks
	 */
	batchCreateLinks: {
		methodKind: "unary";
		input: typeof BatchCreateLinksRequestSchema;
		output: typeof BatchCreateLinksResponseSchema;
	};
	/**
	 * @generated from rpc links.v1.LinksService.CreateDomain
	 */
	createDomain: {
		methodKind: "unary";
		input: typeof CreateDomainRequestSchema;
		output: typeof CreateDomainResponseSchema;
	};
	/**
	 * @generated from rpc links.v1.LinksService.GetLink
	 */
	getLink: {
		methodKind: "unary";
		input: typeof GetLinkRequestSchema;
		output: typeof GetLinkResponseSchema;
	};
	/**
	 * @generated from rpc links.v1.LinksService.DeleteLink
	 */
	deleteLink: {
		methodKind: "unary";
		input: typeof DeleteLinkRequestSchema;
		output: typeof DeleteLinkResponseSchema;
	};
	/**
	 * @generated from rpc links.v1.LinksService.GetDomain
	 */
	getDomain: {
		methodKind: "unary";
		input: typeof GetDomainRequestSchema;
		output: typeof GetDomainResponseSchema;
	};
	/**
	 * @generated from rpc links.v1.LinksService.GetDefaultDomain
	 */
	getDefaultDomain: {
		methodKind: "unary";
		input: typeof GetDefaultDomainRequestSchema;
		output: typeof GetDefaultDomainResponseSchema;
	};
	/**
	 * @generated from rpc links.v1.LinksService.DeleteDomain
	 */
	deleteDomain: {
		methodKind: "unary";
		input: typeof DeleteDomainRequestSchema;
		output: typeof DeleteDomainResponseSchema;
	};
	/**
	 * @generated from rpc links.v1.LinksService.UpdateLink
	 */
	updateLink: {
		methodKind: "unary";
		input: typeof UpdateLinkRequestSchema;
		output: typeof UpdateLinkResponseSchema;
	};
	/**
	 * @generated from rpc links.v1.LinksService.UpdateLinkBatch
	 */
	updateLinkBatch: {
		methodKind: "unary";
		input: typeof UpdateLinkBatchRequestSchema;
		output: typeof UpdateLinkBatchResponseSchema;
	};
	/**
	 * @generated from rpc links.v1.LinksService.UpdateDomain
	 */
	updateDomain: {
		methodKind: "unary";
		input: typeof UpdateDomainRequestSchema;
		output: typeof UpdateDomainResponseSchema;
	};
	/**
	 * @generated from rpc links.v1.LinksService.ListDomains
	 */
	listDomains: {
		methodKind: "unary";
		input: typeof ListDomainsRequestSchema;
		output: typeof ListDomainsResponseSchema;
	};
	/**
	 * @generated from rpc links.v1.LinksService.SetWorkspaceDefault
	 */
	setWorkspaceDefault: {
		methodKind: "unary";
		input: typeof SetWorkspaceDefaultRequestSchema;
		output: typeof SetWorkspaceDefaultResponseSchema;
	};
	/**
	 * @generated from rpc links.v1.LinksService.Redirect
	 */
	redirect: {
		methodKind: "unary";
		input: typeof RedirectRequestSchema;
		output: typeof RedirectResponseSchema;
	};
	/**
	 * @generated from rpc links.v1.LinksService.RedirectCampaign
	 */
	redirectCampaign: {
		methodKind: "unary";
		input: typeof RedirectCampaignRequestSchema;
		output: typeof RedirectCampaignResponseSchema;
	};
	/**
	 * @generated from rpc links.v1.LinksService.GenerateLink
	 */
	generateLink: {
		methodKind: "unary";
		input: typeof GenerateLinkRequestSchema;
		output: typeof GenerateLinkResponseSchema;
	};
	/**
	 * Deprecated: use GetDomainPublicConfig. Returns a domain's full public
	 * config, not just the OneTrust ID. Kept for backward compatibility.
	 *
	 * @generated from rpc links.v1.LinksService.GetDomainOneTrustID
	 * @deprecated
	 */
	getDomainOneTrustID: {
		methodKind: "unary";
		input: typeof GetDomainOneTrustIDRequestSchema;
		output: typeof GetDomainOneTrustIDResponseSchema;
	};
	/**
	 * @generated from rpc links.v1.LinksService.GetDomainPublicConfig
	 */
	getDomainPublicConfig: {
		methodKind: "unary";
		input: typeof GetDomainPublicConfigRequestSchema;
		output: typeof GetDomainPublicConfigResponseSchema;
	};
	/**
	 * @generated from rpc links.v1.LinksService.GetDomainOneTrustConfigs
	 */
	getDomainOneTrustConfigs: {
		methodKind: "unary";
		input: typeof GetDomainOneTrustConfigsRequestSchema;
		output: typeof GetDomainOneTrustConfigsResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_links_v1_links, 0);
